import { ApolloError, useQuery, WatchQueryFetchPolicy } from '@apollo/client';
import { Tenant } from '__generated__/graphql';
import { GET_TENANT } from 'graphql/tenants/queries/getTenant.gql';

export const useGetOneTenantQuery = ({
  id,
  fetchPolicy,
}: {
  id: number;
  fetchPolicy?: WatchQueryFetchPolicy;
}): {
  tenant?: Tenant;
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
} => {
  const { data, error, loading, refetch } = useQuery(GET_TENANT, {
    skip: !id,
    fetchPolicy,
    variables: {
      id,
    },
  });

  return { tenant: data?.tenant, loading, error, refetch };
};
